import { Button } from '@journ/ui/button'
import { Icons } from '@journ/ui/icons'
import { ColumnVisibility } from '@/components/column-visibility'
import { SearchField } from '@/components/search-field'
import { useIntlayer } from 'react-intlayer'
import type { Table } from '@/libs/table'
import type { CompanyWorkflow } from '../domain/workflow'
import { useWorkflowListParams } from './use-workflow-list-params'

type Props = {
	table: Table<CompanyWorkflow>
}

const WorkflowsListHeader = ({ table }: Props) => {
	const content = useIntlayer('workflows-list-page')
	const { q, setParams } = useWorkflowListParams()

	return (
		<div className='flex items-center justify-between gap-4'>
			<SearchField
				placeholder={content.searchPlaceholder.value}
				value={q ?? ''}
				onChange={v => setParams({ q: v })}
			/>
			<div className='flex items-center gap-2'>
				<ColumnVisibility table={table} />
				<Button variant='outline' size='icon' onClick={() => setParams({ createWorkflow: true })}>
					<Icons.Add size={16} />
				</Button>
			</div>
		</div>
	)
}

export { WorkflowsListHeader }
